import React from 'react';
import { Button, Spin } from 'antd';
import s from './s.module.less';
import TableContentItem from './TableContentItem';
import {
    DataManager,
    TabDataManager,
} from '../../utils/dataUpdater';
import { TTableMgmt } from '../../type';
import TableContentModal from './TableContentModal';
import { ServerMeta } from 'types/common';

type Props = {
    dataManager: DataManager;
    condition?: ServerMeta;
};

const TableMgmt = ({ dataManager, condition }: Props) => {
    const [loading] = React.useState(false);
    const [contentModalVisible, setContentModalVisible] = React.useState(false);
    const [selectedTable, setSelectedTable] = React.useState<TTableMgmt | undefined>(undefined);

    // 为tableMgmt tab创建独立的数据管理器
    const [tableTabManager] = React.useState<TabDataManager>(() => {
        return dataManager.createTabManager('tableMgmt');
    });

    // 从tab数据管理器获取tableMgmt数据
    const tableMgmtData = tableTabManager.getTabData('tableMgmt');

    const handleTableSave = async (status: string) => {
        try {
            // 更新table数据
            tableTabManager.updateTabData('status', status);

            // 保存到服务器
            await dataManager.saveDataToServer(
                () => {
                    setContentModalVisible(false);
                    setSelectedTable(undefined);
                },
                (error: any) => {
                    console.error('Failed to save table:', error);
                },
            );
        } catch (error) {
            console.error('Error in handleTableSave:', error);
        }
    };

    const handleContentEdit = () => {
        setSelectedTable(tableMgmtData);
        setContentModalVisible(true);
    };

    return (
        <div className={s.wrap}>
            <div className={s.title}>
                Table management
            </div>

            <Spin spinning={loading}>
                <div className={s.contentSection}>
                    <TableContentItem
                        condition={condition}
                        status={tableMgmtData?.status}
                        onEdit={() => handleContentEdit()}
                    />
                </div>
            </Spin>

            {/* Table Content Modal */}
            <TableContentModal
                visible={contentModalVisible}
                onCancel={() => {
                    setContentModalVisible(false);
                    setSelectedTable(undefined);
                }}
                onSave={handleTableSave}
                condition={condition}
                status={selectedTable?.status}
            />
        </div>
    );
};

export default TableMgmt;
